import { Doctor } from "../../../interfaces/entities/Doctor";
import { FilterInterface } from "../../../interfaces/entities/FilterInterface";
import { TermsOfUse } from "../../../interfaces/entities/TermsOfUse";
import { OrderingDocsEnum } from "../../../interfaces/enum/OrderingDocsEnum";

export const orderingOptionsDefault: FilterInterface[] = [
    {
      id: OrderingDocsEnum.Nome,
      descricao: OrderingDocsEnum.Nome
    },
    {
      id: OrderingDocsEnum.Data,
      descricao: OrderingDocsEnum.Data
    }
]

export const typesOfAppointmentDefault: FilterInterface[] = [
    {id: 'P', descricao: 'Presencial'  },
    {id: 'T',descricao: 'Videochamada'}
]

export const defaultDoctor: Doctor = {
    id: '',
    idEspec: '',
    descrEspec: '',
    nomePessoa: '',
    nomeFantasia: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    cep: '',
    idPessoa: '',
    idEnderPostal: '',
    codConselho: '',
    numConselho: '',
    tipoServico: '',
    telefone:  '',
    idInstal: '',
    dtDispon: '',
    abrevSist: '',
    numDoc: '',
    latitude: '',
    longitude: '',
    distancia: '',
    indExibeSubstituto: '',
    dtExclPrestador: '',
    nomeSubstituto: '',
    idSubstituto: '',
    dtInicSubstituto: '',
    descrMotivoSubstituto: '',
    descrAlerta: '',
    data: '',
    diaSemana: '',
    foneMedico: '',
    emailMedico: '',
    nomePessoaDetalhe: '',
    idFavorito: '',
    crm: ''
}

export const defaultTermsOfUse: TermsOfUse = {
    idTermoResponsabilidade: '',
    codigo: '',
    descricao: '',
    abrevSist: ''
}